import SideView from './sideView';

export * from './sideView';

export default SideView;
